<template>
  <div>
    <h2>心得搜尋</h2>
  </div>
  <div class="container">
    <ModalCom1 :spa="commSpa" :name="commName"></ModalCom1>
    <label style="color: blue">點開下方搜尋條件，依條件搜尋</label>
    <div>
      <a
        class="btn btn-outline-primary"
        data-bs-toggle="collapse"
        href="#collapseExample"
        role="button"
        aria-expanded="false"
        aria-controls="collapseExample"
      >
        搜尋條件
      </a>
    </div>
    <br />
    <div class="collapse" id="collapseExample" style="text-align: left">
      <div class="form-floating">
        <input
          class="form-control"
          id="floatingName1"
          placeholder="尺度"
          v-model="interactive"
        />
        <label for="floatingName1">尺度(ex:大,三光)</label>
      </div>
      <br />
      <div class="form-floating">
        <input
          class="form-control"
          id="floatingName2"
          placeholder="心得"
          v-model="comment"
        />
        <label for="floatingName2">心得(ex:可愛,活潑)</label>
      </div>
      <br />
      <div class="form-floating">
        <input
          class="form-control"
          id="floatingName3"
          placeholder="填寫者"
          v-model="author"
        />
        <label for="floatingName3">填寫者(多個逗號分隔)</label>
      </div>
      <br />
      <div>
        <a
          class="btn btn-outline-success"
          data-bs-toggle="collapse"
          href="#collapseExample1"
          role="button"
          aria-expanded="false"
          aria-controls="collapseExample1"
        >
          店家
        </a>
        &emsp;<label style="color: red">未選預設為全部</label>
      </div>
      <div class="collapse" id="collapseExample1" style="text-align: left">
        <div class="form-check form-check-inline" v-for="spa in spaList" :key="spa.id">
          <input class="form-check-input" type="checkbox" v-model="spa.value" />
          <label class="form-check-label">{{ spa.name }}</label>
        </div>
      </div>
      <br />
      <div>
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="checkbox" v-model="today" />
          <label class="form-check-label">只搜尋當日美容師</label>
        </div>
      </div>
      <br />

      <div style="text-align: center">
        <button type="button" class="btn btn-outline-primary" @click="doSearch()">
          搜尋
        </button>
      </div>
    </div>
  </div>
  <br />

  <div class="container" v-viewer="{ movable: false }">
    <label style="color: red; display: block; margin-bottom: 15px">
      點圖可放大，表格可往右滑
    </label>

    <!-- 表格區塊：直接在表格上加上 v-loading 遮罩 -->
    <viewer>
      <el-table
        v-loading="dataLoading"
        element-loading-text="查詢中..."
        element-loading-background="rgba(255, 255, 255, 0.7)"
        empty-text=" "
        :data="tableItem.slice((currentPage - 1) * pageSize, currentPage * pageSize)"
        border
        style="width: 100%"
        header-cell-class-name="my-header"
        :height="tableHeight"
        :cell-style="tableRowStyle"
      >
        <el-table-column
          v-for="column in columns"
          :key="column.prop"
          :prop="column.prop"
          :label="column.label"
          :width="column.width"
          :fixed="column.fixed"
          :sortable="column.sortable"
        >
          <template #default="scope">
            <img :src="scope.row[column.prop]" v-if="column.show" style="width: 100%" />
            <span v-html="scope.row[column.prop]" v-else-if="column.html" />
            <template v-else-if="column.prop === 'name'">
              <span v-html="format1(scope)" />
              <span>{{ scope.row.name }}</span>
              <br v-if="scope.row.commCount > 0" />
              <button
                v-if="scope.row.commCount > 0"
                type="button"
                class="btn btn-outline-primary btn-sm"
                data-bs-toggle="modal"
                data-bs-target="#exampleModal"
                @click="doButton(scope.row.spa_id, scope.row.name)"
              >
                心得{{ scope.row.commCount }}
              </button>
            </template>
          </template>
        </el-table-column>
      </el-table>
      <div class="el-pagination el-pagination--large" style="margin-top: 15px">
        <el-pagination
          v-model:current-page="currentPage"
          v-model:page-size="pageSize"
          layout="prev, pager, next"
          :total="total"
          @current-change="handleCurrentChange"
        />
      </div>
    </viewer>
  </div>
</template>

<script>
import axios from "axios";
import ModalCom1 from "@/components/ModalCom1.vue";

export default {
  components: {
    ModalCom1,
  },
  data() {
    return {
      tableUrl: "/php/spa_table.php",
      configUrl: "/php/spa_config.php",
      commentUrl: "/php/spa_comment.php",
      currentPage: 1,
      pageSize: 10,
      total: 0,
      interactive: "",
      comment: "",
      author: "",
      today: false,
      dataLoading: false,
      isOr: false,
      spaConfig: [],
      spaList: [
        { id: "spa_01", name: "含香", value: false },
        { id: "spa_02", name: "爵仕堡", value: false },
      ],
      columns: [],
      tableItem: [],
      commentData: [],
      commentNameData: [],
      tableHeight: 500,
      commSpa: "",
      commName: "",
    };
  },
  methods: {
    async selectAll() {
      try {
        const res = await axios.post(this.configUrl, { action: "selectSearchSpa" });
        this.spaConfig = res.data || [];
        this.spaList = this.spaConfig.map((item) => ({
          id: item.id,
          name: item.name,
          value: false,
        }));
      } catch (error) {
        console.error("取得 SPA 設定失敗:", error);
      }
    },

    tableRowStyle({ row }) {
      return {};
    },

    format1(scope) {
      if (1 == scope.cellIndex && "true" == scope.row.day_push) {
        return '<img src="https://imgf.gg9453.com/images/hot.png" height="30" width="60"><br>';
      }
      if (1 == scope.cellIndex && "true" == scope.row.is_new) {
        return '<img src="https://imgf.gg9453.com/images/new2.png" height="30" width="60"><br>';
      }
      return "";
    },

    async doSearch() {
      this.dataLoading = true;
      this.tableItem = [];
      this.commentData = [];
      this.commentNameData = [];
      this.currentPage = 1;

      // 關閉搜尋條件選單
      const myCollapse = document.getElementById("collapseExample");
      if (myCollapse) {
        myCollapse.classList.remove("show");
      }

      // 組裝排外/過濾的 spa 清單
      let notSpa = "";
      for (const spa of this.spaList) {
        if (spa.value) {
          notSpa += ",'" + spa.id + "'";
        }
      }
      if (notSpa) {
        notSpa = notSpa.substring(1);
      }

      try {
        // 1. 先抓取符合條件的心得清單
        const res = await axios.post(this.commentUrl, {
          action: "selectComment",
          interactive: this.interactive.trim(),
          author: this.author.trim(),
          comment: this.comment.trim(),
          notSpa: notSpa,
          isOr: this.isOr,
        });

        if (Array.isArray(res.data)) {
          this.commentData = res.data;
        }

        // 去重 (以 name + spa 為 key)
        for (const temp of this.commentData) {
          const find = this.commentNameData.find(
            (e) => e.name === temp.name && e.spa === temp.spa
          );
          if (!find) {
            this.commentNameData.push(temp);
          }
        }

        // 分組按 Spa 統計美容師名字
        const spaMap = new Map();
        for (const temp1 of this.commentNameData) {
          if (spaMap.has(temp1.spa)) {
            spaMap.get(temp1.spa).push(temp1.name);
          } else {
            spaMap.set(temp1.spa, [temp1.name]);
          }
        }

        // 2. 順序同步查詢：確保上一個查完再查下一個 (使用 for...of 搭配 await)
        for (const [key, value] of spaMap.entries()) {
          let name1 = "";
          value.forEach((element) => {
            name1 += ",'" + element + "'";
          });
          name1 = name1.substring(1);

          if (name1) {
            await this.selectSpa(key, name1);
          }
        }

        this.total = this.tableItem.length;
      } catch (error) {
        console.error("搜尋過程出錯:", error);
      } finally {
        this.dataLoading = false;
      }
    },

    async selectSpa(spaId, name) {
      try {
        const res = await axios.post(this.commentUrl, {
          action: "search",
          spa: spaId,
          name: name,
          today: this.today,
        });

        if (Array.isArray(res.data) && res.data.length > 0) {
          const findSpaName = this.spaConfig.find((e) => e.id === spaId);
          const spaNameStr = findSpaName ? findSpaName.name : "";

          for (const item of res.data) {
            if (item.commCount > 0) {
              item.image = "https://imgf.gg9453.com/images/spa_daily/" + item.image;
              item.spa_name = spaNameStr;

              let ex = "";
              if (item.music === "true") ex += "、送音樂";
              if (item.bento) ex += "、套餐" + item.bento;
              ex = ex.startsWith("、") ? ex.substring(1) : ex;
              item.ex = ex;
              item.spa_id = spaId;

              if (item.name_his) {
                item.info = item.info + "<br>" + item.name_his;
              }

              let week = "";
              if (item.w1) week += "一" + item.w1 + "<br>";
              if (item.w2) week += "二" + item.w2 + "<br>";
              if (item.w3) week += "三" + item.w3 + "<br>";
              if (item.w4) week += "四" + item.w4 + "<br>";
              if (item.w5) week += "五" + item.w5 + "<br>";
              if (item.w6) week += "六" + item.w6 + "<br>";
              if (item.w7) week += "日" + item.w7 + "<br>";
              item.week = week;

              this.tableItem.push(item);
            }
          }
        }
      } catch (error) {
        console.error(`查詢 Spa [${spaId}] 失敗:`, error);
      }
    },

    doButton(spa1, name1) {
      this.commSpa = spa1;
      this.commName = name1;
    },

    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
    },

    initColumns() {
      if (window.innerWidth < 600) {
        this.columns = [
          { prop: "image", label: "照片", show: true, fixed: "left", width: "65px" },
          {
            prop: "name",
            label: "姓名",
            show: false,
            sortable: true,
            fixed: "left",
            width: "85px",
          },
          {
            prop: "work_time",
            label: "可約時段",
            show: false,
            sortable: true,
            width: "120px",
          },
          {
            prop: "week",
            label: "當周報班",
            show: false,
            sortable: false,
            html: true,
            width: "150px",
          },
          {
            prop: "spa_name",
            label: "店家",
            show: false,
            sortable: true,
            width: "80px",
          },
          { prop: "price", label: "台費", show: false, sortable: true, width: "70px" },
          { prop: "height", label: "身高", show: false, sortable: true, width: "70px" },
          { prop: "weight", label: "體重", show: false, sortable: true, width: "70px" },
          { prop: "cup", label: "罩杯", show: false, sortable: true, width: "70px" },
          {
            prop: "info",
            label: "介紹",
            show: false,
            sortable: true,
            html: true,
            width: "300px",
          },
          {
            prop: "ex",
            label: "額外服務",
            show: false,
            sortable: true,
            html: true,
            width: "200px",
          },
        ];
      } else {
        this.columns = [
          { prop: "image", label: "照片", show: true, fixed: "left", width: "200px" },
          {
            prop: "name",
            label: "姓名",
            show: false,
            sortable: true,
            fixed: "left",
            width: "120px",
          },
          {
            prop: "work_time",
            label: "可約時段",
            show: false,
            sortable: true,
            width: "200px",
          },
          {
            prop: "week",
            label: "當周報班",
            show: false,
            sortable: false,
            html: true,
            width: "150px",
          },
          { prop: "price", label: "台費", show: false, sortable: true, width: "90px" },
          {
            prop: "spa_name",
            label: "店家",
            show: false,
            sortable: true,
            width: "90px",
          },
          { prop: "height", label: "身高", show: false, sortable: true, width: "90px" },
          { prop: "weight", label: "體重", show: false, sortable: true, width: "90px" },
          { prop: "cup", label: "罩杯", show: false, sortable: true, width: "90px" },
          {
            prop: "info",
            label: "介紹",
            show: false,
            sortable: true,
            html: true,
            width: "270px",
          },
          {
            prop: "ex",
            label: "額外服務",
            show: false,
            sortable: true,
            html: true,
            width: "200px",
          },
        ];
      }
    },
  },
  created() {
    this.selectAll();
    this.tableHeight = Math.max(window.innerHeight - 300, 500);
    this.initColumns();
  },
};
</script>

<style>
.form-check label {
  margin-left: 4px;
  margin-top: 4px;
  font-size: 18px;
  font-weight: 500;
}
.form-check .form-check-input[type="checkbox"] {
  border-radius: 0.25em;
  height: 25px;
  width: 25px;
}

.my-header {
  background: black !important;
  border-color: black !important;
  font-size: 16px;
  color: white;
}

.el-table__body-wrapper {
  z-index: 2;
}

.el-table .cell {
  font-size: 18px;
  white-space: pre-line;
  overflow: unset;
}
</style>
